import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MGetSkinConcernResponse } from 'src/app/pages/individual-brand/individual-brand.module';
import { UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsBrandService {

  constructor(private httpClient: HttpClient) { }

  getSkinTypeList(): Observable<MGetSkinConcernResponse> {
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.get<MGetSkinConcernResponse>(UtilsService.BASE_URL + UtilsService.SKINTYPELIST, { headers: headers }).pipe(
      map(response => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getSkinConcernList(): Observable<MGetSkinConcernResponse> {
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.get<MGetSkinConcernResponse>(UtilsService.BASE_URL + UtilsService.SKINCONCERNLIST, { headers: headers }).pipe(
      map(response => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }
}
